import * as React from 'react'
import {Link} from "gatsby"

const Overlay = () => {
    return (
        <div>
            <div className="pop-up-media">
                <figure>
                    <img alt="" className="ort-img" src={"/images/Gaibach/teaser-gaibach.jpg"}/>
                    <figcaption>
                        Quelle: Bildarchiv Bayerischer Landtag, Foto: Rolf Poss
                    </figcaption>
                </figure>
            </div>
            <div className="pop-up-body">
                <p className='ort-header'>
                    1828 / 1832: Gaibach </p>
                <p className="ort-subheader">
                    <i>„…einem Staate anzugehören, dessen Verfassung fest gegen äußere und innere Angriffe steht…“</i>
                </p>
                <Link to="/orte/gaibach/" className='ort-text icon-arrow-right load-infobox'>
                    Mehr erfahren
                </Link>
            </div>

        </div>
    )
}

export default Overlay

